import React from 'react';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceUpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';
import { Header } from '../../../../../../components/header';
import { GroupedDevice } from '../../types';
import DeviceItem from '../device-item';

type DeviceGroupProps = {
  groupDevice: GroupedDevice;
  updatesAvailability?: IDeviceUpdateInfo[];
  hiddenHeader?: boolean;
};

const DeviceGroup: React.FC<DeviceGroupProps> = ({ groupDevice, hiddenHeader = false, updatesAvailability = [] }) => (
  <>
    {!hiddenHeader ? <Header title={groupDevice.label} subheader /> : null}
    <ul className="grid-list-24">
      {groupDevice.devices.map((device: IDevice) => {
        const update = updatesAvailability.find((x) => x.UpdateResourceGuid === device.Guid);

        return (
          <li key={device.Guid}>
            <DeviceItem device={device} {...(update ? { update } : {})} />
          </li>
        );
      })}
    </ul>
    <hr className="m-b-24" />
  </>
);

export default DeviceGroup;
